function roundHundred(value){
   return Math.round(value*100)/100;
}

function colorCalc(form) {
  
        var gals = eval(form.dpGallons.value);
        var b1 = roundHundred(gals * .093);
        var b2 = roundHundred(gals * .48);
        var b3 = roundHundred(gals * .95);
        var oz1 = roundHundred(b1 / 2);
        var oz2 = roundHundred(b2 / 2);
        var oz3 = roundHundred(b3 / 2);
        var d1 = gals * 128;
        var d2 = gals * 640;
        var d3 = gals * 1280;
        var imgColor = document.getElementById("colorChoice").value; 
        var color = imgColor;
        
      document.getElementById("colorDisc").className = imgColor;

      if (gals > 0 && color != "") {  
      document.getElementById('drops01').innerHTML = oz1 + 'oz<small><span>' + b1 + '</span><br /> bottles';
      document.getElementById('drops02').innerHTML = oz2 + 'oz <small><span>' + b2 + '</span><br /> bottles';
      document.getElementById('drops03').innerHTML = oz3 + 'oz <small><span>' + b3 + '</span><br /> bottles';
      } 
}